"use client";

// Terminal-framed code card - same window chrome as the homepage API showcase
// (dark panel, traffic lights, filename, copy button).

import { useState } from "react";
import { CodeBlock } from "@/components/shared/code-block";
import { CheckCircleFilled, Copy } from "@/components/icons";

export function TerminalCodeCard({
  code,
  language,
  file,
}: {
  code: string;
  language: string;
  file: string;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="overflow-hidden rounded-[16px] border border-border-secondary bg-(--color-pitch-black)">
      {/* window chrome */}
      <div className="flex items-center gap-2 border-b border-white/8 px-4 py-3">
        <span className="size-3 rounded-full bg-danger/60" />
        <span className="size-3 rounded-full bg-warning/60" />
        <span className="size-3 rounded-full bg-success/60" />
        <span className="ml-2 font-mono text-sm text-[#706D65]">{file}</span>
        <button
          onClick={handleCopy}
          aria-label="Copy code"
          className="ml-auto inline-flex size-7 items-center justify-center rounded-full border border-white/10 text-[#AEA99E] transition-colors hover:text-white hover:border-white/20"
        >
          {copied ? <CheckCircleFilled className="size-3.5 text-success" /> : <Copy className="size-3.5" />}
        </button>
      </div>
      {/* code */}
      <div className="hide-scrollbar overflow-auto text-left">
        <CodeBlock code={code} language={language} showLineNumbers={false} forceDark />
      </div>
    </div>
  );
}
